import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Circle } from 'rc-progress';

const ProgressCircle = (props) => {
    const options = {
        strokeWidth: props.strokeWidth,
        strokeColor: props.strokeColor,
        trailWidth: props.trailWidth,
        trailColor: props.trailColor,
        strokeLinecap: props.strokeLinecap,
        prefixCls: props.prefixCls,
        className: props.className,
        style: props.style,
        percent: props.percent,
        gapDegree: props.gapDegree,
        gapPosition: props.gapPosition,
    };
    const [percent, setPercent] = useState(0);

    // if (props.animate && percent <= props.percent) {
    //     options.percent = percent;
    //     setTimeout(() => {
    //         setPercent(percent + 1);
    //     }, props.timer || 5); // TODO Change timer
    // }

    useEffect(() => {
        let timeout;
        if (props.animate && percent <= props.percent) {
            options.percent = percent;
            timeout = setTimeout(() => {
                setPercent(percent + 1);
            }, props.timer || 5); // TODO Change timer
        }

        return () => {
            clearTimeout(timeout);
        };
    }, [props.animate]);

    return (
        <div
            style={{
                width: props.width,
                height: props.width,
            }}
        >
            <Circle {...options} />
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // bottom: props.width + props.strokeWidth * 2,
                }}
            >
                {props.children}
            </div>
        </div>
    );
};

ProgressCircle.propTypes = {
    animate: PropTypes.bool,
    animationTime: PropTypes.number, // Number in ms
    percent: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object,
        PropTypes.array,
    ]),
    width: PropTypes.number,
    strokeWidth: PropTypes.number,
    strokeColor: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    trailWidth: PropTypes.number,
    trailColor: PropTypes.string,
    strokeLinecap: PropTypes.string,
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    gapDegree: PropTypes.number,
    gapPosition: PropTypes.string,
};

ProgressCircle.defaultProps = {
    animate: false,
    percent: 70,
    width: 'auto',
    strokeWidth: 2,
    trailColor: '#000',
    gapPosition: 'bottom',
};

export default ProgressCircle;
